/* global axios */
import ApiClient from './ApiClient';

class BotFlowsAPI extends ApiClient {
  constructor() {
    super('bot_flows', { accountScoped: true });
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }
}

export default new BotFlowsAPI();
